import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { REACT_APP_API_URL } from '../../../env';


const API_URL = `${REACT_APP_API_URL}/api/hotels`;

// Listing of all hotels
export const fetchHotelDetails = createAsyncThunk(
  'hotelDetails/fetchHotelDetails', async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
)


// Fetch hotel by ID
export const getHotelById = createAsyncThunk(
  'hotelDetails/getHotelById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}/api/hotel/${id}`);
       // return response.data.data;
      return{
        data: response.data.data,
        facilities: response.data.facilities,
        hotelPhotos:response.data.hotelPhotos
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

const hotelDetailsSlice = createSlice({
  name: 'hotelDetails',
  initialState: {
    hotels: [],
    roomsBooked:0,
    hotelById: null,
    loading: false,
    error: null,
  },
  reducers: {
    bookRoom: (state, action) => {
      const incrementBy = action.payload || 1;
      if (state.roomsBooked + incrementBy <= 4) {
        state.roomsBooked += incrementBy;
      } else {
        state.roomsBooked = 4; 
      }
    },

  },
  extraReducers: (builder) => {
    builder
      // For fetching all hotels
      .addCase(fetchHotelDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHotelDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.hotels = action.payload;
      })
      .addCase(fetchHotelDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // For fetching hotel by ID
      .addCase(getHotelById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHotelById.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelById = action.payload;
      })
      .addCase(getHotelById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { bookRoom } = hotelDetailsSlice.actions;
export default hotelDetailsSlice.reducer;
